import { IInvoice } from '../../../types';

export const mapDataForInvoiceWidget = (data: IInvoice[]) =>
  data?.map((item: any) => ({
    invoice: item?.invoiceNumber,
    client: item?.invoiceRecipient?.name,
    clientId: item?.invoiceRecipient?.externalId,
    dueDate: item?.invoicePaymentTerm?.dueDate,
    amount: item?.invoiceService?.amount,
    discount: item?.invoiceService?.discount,
    discountType: item?.invoiceService?.discountType,
    status: item?.invoiceStatus,
    paidTime: item?.paidTime,
    externalId: item?.externalId,
    issueDate: item?.issueDate,
    salesTax: item?.invoiceService?.salesTax,
  }));
